import { render, staticRenderFns } from "./RightsNo1.vue?vue&type=template&id=07bf23cd"
import script from "./RightsNo1.vue?vue&type=script&lang=js"
export * from "./RightsNo1.vue?vue&type=script&lang=js"
import style0 from "./RightsNo1.vue?vue&type=style&index=0&id=07bf23cd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports